import { render, staticRenderFns } from "./PromptPassword.vue?vue&type=template&id=4db93d56&"
import script from "./PromptPassword.vue?vue&type=script&lang=js&"
export * from "./PromptPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports